import React, {Component} from 'react';
import Pause from 'components/Pause';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import introAfterNo from '../../assets/sounds/no/intros/SM_Intro-AFTER-trial.mp3';
import introAfterNn from '../../assets/sounds/nn/intros/SM_Intro-AFTER-trial.mp3';

import ReadyButton from 'components/ReadyButton';

class PauseAfterTrial extends Component {
	constructor(props) {
		super(props);
		this.audio =
			strings.getLanguage() === 'nn' ? introAfterNn : introAfterNo;
	}
	render() {
		return (
			<>
				<p>
					{strings.sm_intro_after_trial_2}
				</p>
			</>
		);
	}
}

export default PauseAfterTrial;
